(function($) {

    // Adds active class on click
    $('.js-filter-toggle').on('click', function() {
        $(this).closest('.filter-dropdown').toggleClass('show');
    });

    $('.js-filter-dropdown .nav-link').on('click', function() {

        $this = $(this);

        // Get href
        // navLinkSrc = $this.attr('href');
        // $('.slick-slider').slick('setPosition');

        $this = $(this);
        toggleValue = $this.html();

        $this
            .closest('.filter-dropdown')
            .removeClass('show')
            .find('.js-filter-toggle')
            .html(toggleValue);

    });

}(jQuery));


(function($) {

    $('.tab-nav .nav-item').on('click', function() {
        //$(this).closest('.tab-nav')
    });

}(jQuery));